import { trackGA4Event, trackGA4PreNav } from './ga4-shared';

declare global {
    interface Window {
        dataLayer: any[];
    }
}

export function trackV2(eventName: string, eventLabel = '', others: any = {}, usePreNav = false) {
    if (!eventLabel && Object.keys(others).length) {
        eventLabel = Object.entries(others)
            .map(([k, v]) => `${k}=${v}`)
            .join('; ')
            .trim();
    }

    let extra: string | undefined = undefined;
    try {
        extra = JSON.stringify(others);
    } catch (_e) {
        // NOOP
    }

    const payload: GA4.GA3LegacyEvent = {
        event: 'ga3_legacy_event',
        legacyEvent: {
            name: eventName,
            label: eventLabel,
            extra,
        },
    };

    if (usePreNav) {
        trackGA4PreNav(payload);
    } else {
        trackGA4Event(payload);
    }
}
